var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeightProportionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33412 8.00087L10.6674 6.66762M7.33424 6.00099L8.66749 4.66774M5.33437 4.00112L6.66762 2.66786M11.334 10.0007L12.6672 8.66749M13.867 9.86728C14.0162 10.0159 14.1345 10.1925 14.2153 10.387C14.296 10.5815 14.3376 10.79 14.3376 11.0005C14.3376 11.2111 14.296 11.4196 14.2153 11.6141C14.1345 11.8086 14.0162 11.9852 13.867 12.1338L12.1338 13.867C11.9852 14.0162 11.8086 14.1345 11.6141 14.2153C11.4196 14.296 11.2111 14.3376 11.0005 14.3376C10.79 14.3376 10.5815 14.296 10.387 14.2153C10.1925 14.1345 10.0159 14.0162 9.86728 13.867L1.46781 5.46756C1.1682 5.1665 1 4.75904 1 4.3343C1 3.90955 1.1682 3.5021 1.46781 3.20103L3.20103 1.46781C3.5021 1.1682 3.90955 1 4.3343 1C4.75904 1 5.1665 1.1682 5.46756 1.46781L13.867 9.86728Z",
    stroke: "#8F333B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightProportionsIcon);
export default __webpack_public_path__ + "static/media/height-proportions-icon.dffcc50d80bed23b4db3c3ae6ac768b8.svg";
export { ForwardRef as ReactComponent };